<template lang="html">
  <div class="pop-up" v-if="isOpen">
    <div class="pop-up-box">
      <h5 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h5 c-accent mt0 mb0">{{ header }}</h5>
      <p class="p mt0 small">{{ copy }}</p>
      <module-button class="mt-tiny mr-tiny" button="primary" @click.native="hitLogin" :label="button.label"/>
      <module-button class="mt-tiny ml0 mr0" @click.native="closeBox" label="Close"/>
    </div>
  </div>
</template>

<script>
// Import

// Modules
import ModuleButton from 'components/Button';

// Vuex
import { mapGetters } from 'vuex';

export default {
  name: 'pop-up',

  components: {
    ModuleButton,
  },

  props: {
    header: String,
    copy: String,
    button: Object,
  },

 

  data() {
    return {
      closeButton: {
        label: 'Close',
        action: this.closeBox,
      },
      isOpen: true,
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
  },

  methods: {
    closeBox() {
      localStorage.removeItem('forcedLogout');
      this.isOpen = false;
      document.getElementsByTagName('BODY')[0].classList.remove('ovh');
    },

    hitLogin() {
      this.closeBox();
      this.$router.push({ name: this.button.link });
    },
  },

  beforeCreate() {
    document.getElementsByTagName('BODY')[0].classList.add('ovh');
  },
};
</script>



// WEBPACK FOOTER //
// PopUp.vue?a673a106